import React, { createContext, useState, ReactNode, useContext } from "react";

interface ScreenContextType {
  currentScreen: any;
  setCurrentScreen: any;
}

export const ChatSidebarScreenContext = createContext<ScreenContextType>({
    currentScreen: "",
    setCurrentScreen: () => {},
});

interface ScreenProviderProps {
  children: ReactNode;
}

export const ChatSidebarCurrentScreenProvider = ({ children }: ScreenProviderProps) => {
  const [currentScreen, setCurrentScreen] = useState<any>("chats");

  return (
    <ChatSidebarScreenContext.Provider value={{ currentScreen, setCurrentScreen }}>
      {children}
    </ChatSidebarScreenContext.Provider>
  );
};

export const useChatSidebarContext = (): ScreenContextType => {
  const context = useContext(ChatSidebarScreenContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
